export const actionChangeDataFindLocation = (lat,lng) => ({
    type: 'CHANGE_DATA_FIND_LOCATION',lat,lng
});
export const actionChangeLoaderFindLocationMap = (loaderFindLocation) => ({
    type: 'CHANGE_LOADER_FINAL_LOCATION_MAP',loaderFindLocation
});
